const menuBurger = document.getElementById('menu-burger');
const mobileMenu = document.querySelector('.mobile-menu');
const mainPanel = document.querySelector('.mobile-menu__panel--main');
const productsPanel = document.querySelector('.mobile-menu__panel--products');
const backButton = document.querySelector('.mobile-menu__back-button');
const productsContainer = document.querySelector('.mobile-menu__products-container');

menuBurger.addEventListener('click', () => {
  const isOpen = document.body.classList.toggle('menu-open');
  menuBurger.classList.toggle('menu-burger--active', isOpen);

  if (!isOpen) {
    mainPanel.classList.add('active');
    productsPanel.classList.remove('active');
    productsContainer.innerHTML = '';
  }
});

document.querySelectorAll('.mobile-menu__item').forEach(item => {
  const submenu = item.querySelector('.submenu');
  if (submenu) {
    item.addEventListener('click', e => {
      e.preventDefault();
      productsContainer.innerHTML = submenu.innerHTML;
      backButton.textContent = item.getAttribute('data-title');
      mainPanel.classList.remove('active');
      productsPanel.classList.add('active');
    });
  }
});

backButton.addEventListener('click', () => {
  productsPanel.classList.remove('active');
  mainPanel.classList.add('active');
  productsContainer.innerHTML = '';
});